import { render, staticRenderFns } from "./hotel_info.vue?vue&type=template&id=034784e4&scoped=true&"
import script from "./hotel_info.vue?vue&type=script&lang=js&"
export * from "./hotel_info.vue?vue&type=script&lang=js&"
import style0 from "./hotel_info.vue?vue&type=style&index=0&id=034784e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034784e4",
  null
  
)

export default component.exports